import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { SH_INVOICE } from 'sh-www/models/sh-invoice';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

const INVOICES_QUERY_PARAMS = [
  'sort',
  'secondary_sort',
  'payment_state',
  'cost_code',
  'story_code',
].reduce((accum, param) => {
  accum[param] = { refreshModel: true, replace: true };
  return accum;
}, { });

class ReportsInvoicesRoute extends Route {
  @service session;
  @service store;

  get queryParams() {
    return INVOICES_QUERY_PARAMS;
  }

  async model() {
    const { company } = this.session.currentUser;
    const invoiceFactoids = await this.store.query('factoid', {
      type: SH_INVOICE.FACTOID_TYPE,
      filter: {
        company_id: company.id,
      },
    });

    return {
      invoiceFactoids,
    };
  }

  /** @inheritDoc */
  setupController(controller, _, transition) {
    super.setupController(...arguments);

    // only buyer's view uses new pattern
    if (this.session.currentUser.isBuyer) {
      const { queryParams } = transition.to;

      if (!controller.modelIsValid(queryParams)) {
        controller.reloadModel.perform(queryParams);
      }
    }
  }

   /** @inheritDoc */
   resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (!!isExiting) {
      return;
    }

    controller.invalidateModel.perform();
  }

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/reports/invoices/');
  }
}

export default ReportsInvoicesRoute;
